import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';

import * as yup from 'yup';

/** Payer status response body - DTO signature */
export interface PayerStatusFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: string;

  // Tech columns
  /** Payer status creation date and type */
  created: Date;
  /** Payer status last update date and type */
  updated: Date;
  /** Payer status soft deletion date and type */
  deleted?: Date;

  // Data columns
  /** Payer status unique code */
  code: string;
  /** Payer status display name */
  name: string;
  /** Payer status expiration mark */
  expired?: boolean;
}

/** Payer status response body - DTO schema */
export const PayerStatusFindDto = SerdeDtoClass.create<PayerStatusFindInterface>(CatalogDtosKeysEnum.PAYER_STATUS_FIND_DTO, {
  id: {
    sortable: true,
    label: 'Номер',
    serializer: yup.string(),
  },
  created: {
    label: 'Создан',
    serializer: yup.date(),
  },
  updated: {
    label: 'Изменен',
    serializer: yup.date(),
  },
  deleted: {
    optional: true,
    label: 'Удален',
    serializer: yup.date(),
  },
  code: {
    sortable: true,
    label: 'Код',
    serializer: yup.string(),
  },
  name: {
    sortable: true,
    label: 'Название',
    serializer: yup.string(),
  },
  expired: {
    sortable: true,
    optional: true,
    label: 'Устаревший статус',
    hint: 'Пометка для устаревших статусов плательщика (такое может быть, так как наборы статусов периодически меняются)',
    serializer: yup.boolean(),
  },
});
